const mobileMenu = () => {
  const mobileMenu = document.getElementById('js-mobile-menu'),
    openMobileMenuBtn = document.getElementById('js-toggle-mobile-menu-btn'),
    header = document.getElementById('js-header'),
    html = document.getElementsByTagName('html')[0]

  openMobileMenuBtn &&
    openMobileMenuBtn.addEventListener('click', (e) => {
      e.preventDefault()
      toggleMenu(e)
    })

  const toggleMenu = (e) => {
    e.target.classList.toggle('js-pressed')
    mobileMenu.classList.toggle('js-show-menu')
    html.classList.toggle('js-noscroll-mobile')

    if (
      header.classList.contains('header-transparent') ||
      header.classList.contains('header-solid-mobile')
    ) {
      header.classList.toggle('header-transparent')
      header.classList.toggle('header-solid')
      header.classList.toggle('header-solid-mobile')
    }

    mobileMenu.classList.contains('js-show-menu')
      ? left(`0%`)
      : closeMenus(`100%`)
  }

  const closeMenus = (val) => {
    left(val)
    setTimeout(() => {
      mobileMenu
        .querySelectorAll('.js-children-active')
        .forEach((elm) => elm.classList.remove('js-children-active'))
    }, 350)
  }

  mobileMenu.addEventListener('click', (e) => {
    if (e.target instanceof HTMLAnchorElement) return

    e.preventDefault()
    const currentLeft = parseFloat(mobileMenu.style.left)

    if (e.target.classList.contains('js-toggle-children')) {
      e.target.parentElement.classList.add('js-children-active')
      left(`${currentLeft - 100}%`)
    } else if (e.target.classList.contains('js-show-parent')) {
      closeMenus(`${currentLeft + 100}%`)
    }
  })

  const left = (val) => {
    return (mobileMenu.style.left = val)
  }
}

export default mobileMenu
